// Defaults for every editable string on the site.
// Structure: flat namespaces like "hero.pill1", "manifesto.body" — makes it easy
// to render as an admin form and to override selectively.
export const DEFAULT_CONTENT = {
  hero: {
    pill1: "Seleção 2026",
    pill2: "Somente 10 vagas",
    pill3: "A convite",
    eyebrow: "Retiro Alta Agency  ·  Shambala House  ·  São Paulo",
    title1: "Casa ",
    title2: "Alta",
    subline_prefix: "Onde a estética encontra o ",
    subline_accent: "conteúdo absoluto.",
    data_tag: "Data",
    data_value: "04—06",
    data_sub: "agosto · 2026",
    local_tag: "Local",
    local_value: "Moema",
    local_sub: "São Paulo · BR",
    formato_tag: "Formato",
    formato_value: "3 dias",
    formato_sub: "fechado · 10 vagas",
    cta_primary: "Ativar meu convite",
    cta_secondary: "Ainda sem convite? Candidate-se →",
    cta_email: "contato@altaagency.com.br",
    scroll_cue: "Role para descobrir",
  },
  manifesto: {
    eyebrow: "Manifesto",
    date_note: "04 — 06 · agosto · 2026",
    body_pre: "Três dias de imersão privada para uma ",
    body_accent: "seleção reservada",
    body_post: " de criadoras. Uma residência de arquitetura contemporânea, cercada por concreto, vidro e uma vegetação que apaga o ruído da cidade — desenhada para produção de conteúdo, descanso e encontro.",
    stat1_k: "3",
    stat1_v: "Dias de imersão criativa",
    stat2_k: "04",
    stat2_v: "Cenários curados de produção",
    stat3_k: "10",
    stat3_v: "Vagas · seleção reservada",
  },
  cast: {
    eyebrow: "O Elenco",
    title1: "As criadoras",
    title2: "que fazem",
    title_accent: "a Alta.",
    body: "Mais de 50 criadoras já geraram, juntas, mais de R$25 milhões com a Alta em 2025 e 2026. Este retiro reúne apenas 10 nomes selecionados — as vozes, corpos e personalidades que definem o conteúdo hoje.",
    footnote: "Curadoria Alta · 2026",
    // creators: array dinâmico (nova estrutura). Cada item: {id, src, handle, vibe, reveal}
    // O card com reveal=true funciona como "vaga surpresa" e pode ficar em qualquer posição.
    creators: [
      { id: "c1", src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/m454von1_image.png", handle: "@sunny.bikini", vibe: "Praia · Cover", reveal: false },
      { id: "c2", src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/qkv7xk37_image.png", handle: "@laranja.studio", vibe: "Estúdio · Moda", reveal: false },
      { id: "c3", src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/993fp968_image.png", handle: "@axe.trancinhas", vibe: "Direto para câmera · Lifestyle", reveal: false },
      { id: "c4", src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/lfdrt23k_image.png", handle: "@ruiva.on", vibe: "Retrato · Editorial", reveal: false },
      { id: "c5", src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/hpngopu0_image.png", handle: "@rede.selfie", vibe: "Bastidores · Rede", reveal: false },
      { id: "c6", src: "", handle: "@?????", vibe: "Revelação · 08.2026", reveal: true },
    ],
    // Legacy p1..p6 (mantidos para compat retroativa; usados apenas se creators estiver vazio).
    p1_src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/m454von1_image.png",
    p1_handle: "@sunny.bikini", p1_vibe: "Praia · Cover", p1_reveal: false,
    p2_src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/qkv7xk37_image.png",
    p2_handle: "@laranja.studio", p2_vibe: "Estúdio · Moda", p2_reveal: false,
    p3_src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/993fp968_image.png",
    p3_handle: "@axe.trancinhas", p3_vibe: "Direto para câmera · Lifestyle", p3_reveal: false,
    p4_src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/lfdrt23k_image.png",
    p4_handle: "@ruiva.on", p4_vibe: "Retrato · Editorial", p4_reveal: false,
    p5_src: "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/hpngopu0_image.png",
    p5_handle: "@rede.selfie", p5_vibe: "Bastidores · Rede", p5_reveal: false,
    p6_src: "", p6_handle: "@?????", p6_vibe: "Revelação · 08.2026", p6_reveal: true,
  },
  shotlist: {
    eyebrow: "Os Cortes",
    title: "O que você leva pra casa.",
    body: "Cada retiro é um set de produção completo. Estes são os entregáveis mínimos por criadora ao final dos três dias — direção, edição e finalização Alta inclusas.",
    i1_n: "20", i1_label: "Retratos editoriais", i1_sub: "Suíte master · luz dourada",
    i2_n: "08", i2_label: "Reels prontos", i2_sub: "Cortes de moda · piscina · fogueira",
    i3_n: "04", i3_label: "Capas de moda", i3_sub: "Solário · direto para câmera",
    i4_n: "15", i4_label: "Stories vertical", i4_sub: "Bastidores · fitness · gastronomia",
    i5_n: "02", i5_label: "Mini-vídeos de moda", i5_sub: "Direção Alta · finalização inclusa",
    i6_n: "01", i6_label: "Capa editorial", i6_sub: "Publicação nas redes Alta",
  },
  scenarios: {
    eyebrow: "As Locações",
    title: "Quatro cenários, uma residência.",
    body: "Cada ambiente da Shambala foi mapeado como um estúdio natural. Uma coleção de luzes, texturas e materiais para produzir sem sair de casa.",
    s1_tag: "01 — O Oásis",
    s1_title: "Piscina de ozônio, 4 m de profundidade",
    s1_body: "Cristalina, aquecida por energia solar, com trampolim de inox de três metros. Cercada por poltronas flutuantes e uma vegetação que apaga a cidade.",
    s2_tag: "02 — O Terraço",
    s2_title: "Concreto, vidro e o céu de São Paulo",
    s2_body: "Escadas de concreto, três varandas, jacuzzi Yemanjá aquecida solar e um tacho de fogo pronto para noites estreladas. Onde o dia termina.",
    s3_tag: "03 — O Estúdio",
    s3_title: "Suíte master, integrada às varandas",
    s3_body: "Cama king, luz da manhã abundante, acesso direto ao trampolim. Um estúdio natural para moda, retratos e séries de conteúdo.",
    s4_tag: "04 — O Laboratório",
    s4_title: "Quartos, academia envidraçada & sauna úmida",
    s4_body: "Três suítes tratadas como cenários: linho, tons terrosos e muita luz natural. Ao lado, academia com vista panorâmica e sauna úmida para o corpo lembrar de descansar.",
  },
  timeline: {
    // Day metadata
    d1_day: "Dia I", d1_date: "04.08.2026", d1_theme: "Chegada. Silêncio. Escolha da luz.",
    d2_day: "Dia II", d2_date: "05.08.2026", d2_theme: "Produção. Corpo. Estética.",
    d3_day: "Dia III", d3_date: "06.08.2026", d3_theme: "Legado. Encerramento.",

    // Day 1 — 3 items
    d1_i1_time: "17h00", d1_i1_title: "Check-in & Recepção", d1_i1_desc: "Boas-vindas com welcome-drink no lobby de concreto.",
    d1_i2_time: "18h30", d1_i2_title: "Tour pelos Cenários", d1_i2_desc: "Passeio pelas varandas com curadoria de bebidas e primeiro contato com os cenários.",
    d1_i3_time: "20h30", d1_i3_title: "Jantar ao redor da fogueira", d1_i3_desc: "Menu autoral no Solário. Fogo, céu aberto e conversas longas.",
    d1_i4_time: "", d1_i4_title: "", d1_i4_desc: "",
    d1_i5_time: "", d1_i5_title: "", d1_i5_desc: "",
    d1_i6_time: "", d1_i6_title: "", d1_i6_desc: "",

    // Day 2 — 5 items
    d2_i1_time: "08h00", d2_i1_title: "Café da manhã gourmet", d2_i1_desc: "Na cozinha aberta, com luz da manhã e frutas do dia.",
    d2_i2_time: "09h30", d2_i2_title: "Sessão de fotos 01", d2_i2_desc: "Piscina de ozônio e academia envidraçada.",
    d2_i3_time: "15h00", d2_i3_title: "Sessão de fotos 02", d2_i3_desc: "Suíte master, luz natural, moda editorial.",
    d2_i4_time: "18h00", d2_i4_title: "Pôr do sol na Jacuzzi", d2_i4_desc: "Cobertura, taças e o céu de São Paulo derretendo em laranja.",
    d2_i5_time: "20h30", d2_i5_title: "Jantar harmonizado", d2_i5_desc: "Menu degustação, vinho e conteúdo lento.",
    d2_i6_time: "", d2_i6_title: "", d2_i6_desc: "",

    // Day 3 — 3 items
    d3_i1_time: "08h30", d3_i1_title: "Café da manhã", d3_i1_desc: "Último café coletivo, no jardim.",
    d3_i2_time: "10h00", d3_i2_title: "Gravação em grupo", d3_i2_desc: "Vídeos rápidos, entregáveis e agradecimentos.",
    d3_i3_time: "12h00", d3_i3_title: "Check-out", d3_i3_desc: "Encerramento oficial. O que fica é o material — e a memória.",
    d3_i4_time: "", d3_i4_title: "", d3_i4_desc: "",
    d3_i5_time: "", d3_i5_title: "", d3_i5_desc: "",
    d3_i6_time: "", d3_i6_title: "", d3_i6_desc: "",
  },
  bagagem: {
    eyebrow: "A Bagagem",
    title: "O que trazer\nna mala.",
    body: "Cada cenário pede uma linguagem visual própria. Este é o briefing de bagagem que preparamos para você chegar pronta — separado por ambiente da Shambala.",
    footnote: "Guia de produção Alta · 2026",

    c1_title: "Piscina & Trampolim Inox",
    c1_tag: "Cortes de moda · Reels",
    c1_looks: "• Biquínis variados (fita, asa delta, amarrações)\n• Maiôs cavados e elegantes (pretos, brancos ou cores vibrantes)\n• Saídas de praia fluidas, camisas abertas ou saias transparentes",
    c1_extras: "• Óculos de sol de grife\n• Roupão de cetim ou felpudo\n• Puffs flutuantes já disponíveis no local",

    c2_title: "Solário, Jacuzzi & Fogueira",
    c2_tag: "Capas de moda · Reels",
    c2_looks: "• Lingerie vermelha, preta ou em tons terrosos\n• Looks aconchegantes e sensuais para a fogueira (casacos oversized, tricô macio, bodies de manga longa)\n• Biquínis metalizados ou com pedrarias para a jacuzzi",
    c2_extras: "• Toalha de banho extra e confortável\n• Presilhas de cabelo elegantes\n• Joias e brincos brilhantes para fotos noturnas",

    c3_title: "Suíte Master & Varandas",
    c3_tag: "Retratos editoriais · Covers",
    c3_looks: "• Lingeries de luxo (rendadas, conjuntos com cinta-liga, bodies transparentes)\n• Camisas sociais brancas masculinas (oversized)\n• Baby-dolls delicados e robes de seda",
    c3_extras: "• Saltos altos que combinem com as lingeries\n• Perfume marcante\n• Máscara para dormir elegante (cenário “acordando”)",

    c4_title: "Academia Panorâmica",
    c4_tag: "Stories · bastidores fitness",
    c4_looks: "• Conjuntos fitness premium (tops, leggings e shorts curtos e colados)\n• Bodies esportivos cavados\n• Meias brancas de cano alto",
    c4_extras: "• Tênis esportivo limpo\n• Garrafa de água estilosa (linha Stanley ou similar)\n• Fones de arco (estilo headphone)",

    c5_title: "Cozinha Moderna & Gastronomia",
    c5_tag: "Stories · descontraído",
    c5_looks: "• Looks casuais e sensuais (shorts jeans curtos, camisetas oversized sem sutiã propositalmente, croppeds de algodão)\n• Lingerie básica de algodão branca ou cinza (estilo Calvin Klein)",
    c5_extras: "• Caneca estilosa para fotos com café\n• Presilha de cabelo (estilo piranha) para o look “descontraído de manhã”",

    p_eyebrow: "Preparação Pessoal",
    p_title: "Higiene, estética\ne preparação.",
    p_body: "Para o fluxo de gravação ser perfeito, chegue com esses itens em dia — a produção Alta cuida do resto no set.",

    p1_title: "Estética Corporal",
    p1_body: "Depilação, unhas (mão e pé) feitas em cores neutras ou clássicas (francesinha, nude ou vermelho) e hidratação da pele em dia antes de embarcar.",
    p2_title: "Cabelo & Maquiagem",
    p2_body: "Traga sua própria necessaire completa de maquiagem (foco em bases de alta cobertura e longa duração) e seus finalizadores de cabelo (babyliss, chapinha ou secador de preferência).",
    p3_title: "Essenciais de Higiene",
    p3_body: "Escova de dente, pasta, desodorante neutro (evita marcas nas roupas), hidratante corporal iluminador (efeito glow nas fotos de solário e piscina) e protetor solar.",
  },
  gate: {
    eyebrow: "Entrada oficial",
    title_pre: "Sua presença",
    title_accent: "é reservada.",
    body: "O acesso ao cronograma, endereço e horários é restrito a criadoras selecionadas pela Alta Agency. Insira o código enviado para você.",
    input_label: "Código de convidado",
    button: "Acessar Programação",
    confidential: "Confidencial",
  },
  footer: {
    title: "Shambala House",
    tagline: "uma curadoria Alta Agency — 2026",
    body: "Um retiro editorial fechado. Endereço, cronograma e detalhes operacionais liberados apenas aos convidados confirmados.",
    curadoria_label: "Curadoria",
    curadoria_value: "Alta Agency",
    local_label: "Locação",
    local_value: "Moema · SP",
  },
  guest: {
    // -------- Login page (CodeEntry) --------
    login_pill_a: "Área reservada",
    login_pill_b: "Convite pessoal",
    login_eyebrow: "Casa Alta  ·  04—06 Ago 2026  ·  Shambala House",
    login_title_pre: "Sua ",
    login_title_accent: "chave",
    login_body_pre: "O acesso ao cronograma, endereço e RSVP é liberado apenas com o código pessoal enviado individualmente pela ",
    login_body_accent: "Alta Agency",
    login_body_post: ".",
    login_field_label: "Insira sua chave de acesso",
    login_placeholder: "SHAMBALA · ALTA · VIP",
    login_button: "Destravar acesso",
    login_button_loading: "Verificando...",
    login_disclaimer: "Pessoal · Intransferível · Confidencial",
    login_help: "Sem convite? Escreva para contato@altaagency.com.br",

    // -------- Welcome hero --------
    welcome_pill_aguarda: "Sua vaga aguarda",
    welcome_pill_confirmada: "Presença confirmada",
    welcome_edition_tag: "Casa Alta 2026",
    welcome_eyebrow: "Retiro Alta Agency  ·  Shambala House  ·  04—06 Ago 2026",
    welcome_greeting: "Olá,",
    welcome_body_pre: "Sua presença foi reservada nominalmente. Abaixo, um passeio pelo que preparamos — ",
    welcome_body_accent: "a casa, o elenco, os cenários",
    welcome_body_post: " — e o formulário para confirmar sua vaga.",
    welcome_cta_confirm: "Confirmar minha vaga",
    welcome_cta_edit: "Editar minha confirmação",
    welcome_cta_note: "Assinatura do termo · 2 min",
    welcome_scroll_cue: "Role para explorar",

    // -------- Guest sub-nav labels --------
    subnav_inicio: "Início",
    subnav_cenarios: "Cenários",
    subnav_elenco: "Elenco",
    subnav_cortes: "Cortes",
    subnav_bagagem: "Bagagem",
    subnav_agenda: "Agenda",
    subnav_confirmar: "Confirmar vaga →",

    // -------- Guest top nav labels --------
    nav_badge: "Convite ativado",
    nav_logout: "Sair",
    nav_confirm_short: "Confirmar vaga →",

    // -------- Info strip (4 cells) --------
    info_localizacao_label: "Localização",
    info_localizacao_value: "Moema · São Paulo, SP",
    info_checkin_label: "Check-in",
    info_checkin_value: "04 · ago · 2026 — 17h00",
    info_checkout_label: "Check-out",
    info_checkout_value: "06 · ago · 2026 — 12h00",
    info_dress_label: "Dress code",
    info_dress_value: "Editorial · resort contemporâneo",

    // -------- Timeline (headers) --------
    timeline_eyebrow: "Programação",
    timeline_title: "Três dias, uma coreografia precisa.",

    // -------- RSVP form --------
    rsvp_eyebrow: "RSVP",
    rsvp_title_pre: "Confirme",
    rsvp_title_accent: "sua vaga.",
    rsvp_body: "Suas informações são confidenciais e serão usadas exclusivamente para curadoria de conteúdo, hospitalidade e presentes exclusivos dos patrocinadores.",
    rsvp_already_note: "✓ Você já confirmou. Editar reenviará seus dados.",
    rsvp_field_name: "Nome completo",
    rsvp_field_social: "Perfil Instagram / TikTok",
    rsvp_field_social_placeholder: "@seuperfil",
    rsvp_field_diet: "Restrições alimentares",
    rsvp_field_diet_placeholder: "Se houver — vegana, sem glúten, alergias...",
    rsvp_field_clothing: "Tamanho de roupa",
    rsvp_field_clothing_placeholder: "PP · P · M · G · GG",
    rsvp_field_shoe: "Tamanho de calçado",
    rsvp_field_shoe_placeholder: "Ex: 38",
    rsvp_termo_pill: "Termo obrigatório",
    rsvp_signature_label: "Assino como (nome completo)",
    rsvp_signature_placeholder: "Ex: Maria Silva de Oliveira",
    rsvp_consent_pre: "Li e concordo integralmente com todas as cláusulas do",
    rsvp_consent_accent: " Termo de Uso de Imagem e Voz ",
    rsvp_consent_post: "do Casa Alta 2026.",
    rsvp_submit_new: "Assinar e confirmar minha vaga",
    rsvp_submit_edit: "Atualizar confirmação",
    rsvp_submit_loading: "Enviando...",
    rsvp_submit_hint: "Aceite o termo acima para liberar o envio.",

    // -------- Closing --------
    closing_eyebrow: "Até logo",
    closing_line_pre: "Nos vemos em ",
    closing_line_accent: "agosto",

    // -------- Footer --------
    footer_line: "Alta Agency · 2026",
    footer_logout: "Encerrar sessão",
  },
  reality: {
    // -------- Nav --------
    nav_tag: "Reality · Estreia 22.09",
    nav_trailer: "Trailer",
    nav_watch: "Episódios",
    nav_cta: "Inscrever-se no canal →",
    nav_back: "Site do evento",

    // -------- Hero --------
    hero_video: "https://customer-assets-jt897jd0.emergentagent.net/job_shambala-retreat/artifacts/m4uzkbg8_CasaAlta_Trailer_Oficial_16x9_v3_preview.mp4",
    trailer_youtube_url: "https://www.youtube.com/watch?v=_iA9rrS7jGw",
    cta_trailer: "Assistir ao trailer",
    trailer_label: "Trailer oficial · Casa Alta",
    trailer_title: "Sete criadoras. Três dias. Nenhum roteiro.",
    trailer_youtube_label: "Ver no YouTube",
    trailer_poster: "",
    premiere_date: "2026-09-22T20:00:00-03:00",
    premiere_url: "https://www.youtube.com/@AltaCreatorsTV?sub_confirmation=1",
    premiere_label: "Estreia oficial",
    premiere_date_text: "22 de setembro",
    countdown_days: "dias", countdown_hours: "horas", countdown_min: "min", countdown_sec: "seg",
    countdown_live: "No ar agora",
    pill1: "Reality Casa Alta",
    pill2: "4 episódios",
    pill3: "Estreia 22.09",
    eyebrow: "Alta Agency apresenta",
    title1: "Casa",
    title2: "Alta",
    title_sub: "O reality",
    headline: "Sete criadoras. Três dias. Nenhum roteiro.",
    subline_prefix: "Quatro episódios. Uma estreia. ",
    subline_accent: "22 de setembro, no canal da Alta.",
    cta_primary: "Inscrever-se no canal da Alta",
    cta_secondary: "Ver os episódios ↓",
    meta_1_k: "Estreia", meta_1_v: "22.09", meta_1_s: "canal da Alta · YouTube",
    meta_2_k: "Episódios", meta_2_v: "04", meta_2_s: "um a um, sem cortes",
    meta_3_k: "Criadoras", meta_3_v: "07", meta_3_s: "Shambala House · SP",

    // -------- Marquee --------
    marquee: "Sem roteiro · Sem filtro · Sem plateia · Estreia 22 de setembro · 4 episódios · Casa Alta",

    // -------- Manifesto --------
    m_eyebrow: "O que aconteceu lá dentro",
    m_title: "Não foi um evento.\nFoi um antes e depois.",
    m_body: "Sete criadoras selecionadas a dedo. Uma residência fechada em Moema. Três dias de produção, direção e conversas que não cabem em um story. O que você vai ver nos episódios é o que sobrou quando as câmeras esqueceram de desligar.",
    m_stat1_k: "07", m_stat1_v: "criadoras dentro da casa",
    m_stat2_k: "72h", m_stat2_v: "de câmera ligada",
    m_stat3_k: "04", m_stat3_v: "episódios · estreia 22.09",
    m_quote: "“Entrei achando que era um retiro. Saí entendendo o que é ser marca.”",
    m_quote_by: "Criadora · Casa Alta",

    // -------- Elenco --------
    cast_eyebrow: "O elenco",
    cast_title: "Sete criadoras.\nSete jeitos de não ter medo.",
    cast_body: "Selecionadas a dedo, de estilos que não se repetem. Algumas você já segue. Outras vai passar a seguir depois do episódio 01.",
    cast_soon_label: "Em breve",
    cast_soon_hint: "Revelação nos próximos dias",
    // cast: array dinâmico. photo vazio = card "Em breve".
    cast: [
      { id: "c1", name: "Mel", handle: "", tag: "Criadora · Casa Alta", photo: "https://customer-assets-jt897jd0.emergentagent.net/job_shambala-retreat/artifacts/3zzfvre7_elenco_mel_4x5.jpg" },
      { id: "c2", name: "Psy", handle: "", tag: "Criadora · Casa Alta", photo: "https://customer-assets-jt897jd0.emergentagent.net/job_shambala-retreat/artifacts/2t6v6mfj_elenco_psy_4x5.jpg" },
      { id: "c3", name: "Sassy", handle: "", tag: "Criadora · Casa Alta", photo: "https://customer-assets-jt897jd0.emergentagent.net/job_shambala-retreat/artifacts/2jex3v0h_elenco_sassy_4x5.jpg" },
      { id: "c4", name: "Iara", handle: "", tag: "Criadora · Casa Alta", photo: "https://customer-assets-jt897jd0.emergentagent.net/job_shambala-retreat/artifacts/2x3hzp3w_elenco_iara_4x5.jpg" },
      { id: "c5", name: "Cigana", handle: "", tag: "Criadora · Casa Alta", photo: "/cast/cigana_v2_4x5.jpg" },
      { id: "c6", name: "Fooquinha", handle: "", tag: "Criadora · Casa Alta", photo: "https://customer-assets-jt897jd0.emergentagent.net/job_shambala-retreat/artifacts/jzwerqvj_elenco_fooquinha_4x5.jpg" },
      { id: "c7", name: "Julssy", handle: "", tag: "Criadora · Casa Alta", photo: "https://customer-assets-jt897jd0.emergentagent.net/job_shambala-retreat/artifacts/i0m12obb_elenco_julssy_4x5.jpg" },
    ],

    // -------- Episodes --------
    ep_eyebrow: "Os episódios",
    ep_title: "Quatro capítulos.\nUma estreia.",
    ep_body: "A partir de 22 de setembro, no canal da Alta no YouTube. Inscreva-se e ative o lembrete — o primeiro episódio não avisa duas vezes.",
    ep_label: "Episódio",
    coming_soon_label: "Em breve",
    coming_soon_hint: "Estreia 22.09 · no canal da Alta",
    watch_label: "Assistir agora",
    channel_url: "https://www.youtube.com/@AltaCreatorsTV",
    channel_label: "Inscrever-se no canal da Alta →",
    // episodes: array dinâmico. youtube_id vazio = card bloqueado "Em breve".
    episodes: [
      { id: "e1", number: "01", title: "As Sete Estranhas", desc: "Sete desconhecidas, um portão que só abre por dentro e a primeira pergunta que ninguém quis responder.", youtube_id: "", duration: "" },
      { id: "e2", number: "02", title: "A primeira noite", desc: "Muita treta, alianças fechadas no escuro e um beijo na boca que ninguém viu chegar.", youtube_id: "", duration: "" },
      { id: "e3", number: "03", title: "O dia seguinte", desc: "Fofoca, banho de banheira e a realidade de ter que encarar uma a outra à luz do dia.", youtube_id: "", duration: "" },
      { id: "e4", number: "04", title: "O Legado", desc: "Check-out. O que cada uma levou pra casa — e o que deixou lá.", youtube_id: "", duration: "" },
    ],

    // -------- Bloco vermelho · A estreia --------
    p_eyebrow: "22 de setembro",
    p_title: "Marque na agenda.\nA casa abre às 20h.",
    p_body: "Quatro episódios, publicados um a um no canal da Alta. Sem spoiler, sem corte bonito, sem segunda chance de ver a primeira reação. Quem ativa o lembrete assiste antes de todo mundo comentar.",
    p1_k: "01", p1_t: "Onde assistir", p1_d: "No canal da Alta no YouTube. Gratuito, aberto, em alta definição.",
    p2_k: "02", p2_t: "Como não perder", p2_d: "Inscreva-se no canal da Alta e ative o sininho. A estreia chega direto no seu celular.",
    p3_k: "03", p3_t: "O que esperar", p3_d: "Sete criadoras, três dias, zero roteiro. O resto você descobre no episódio 01.",
    p_cta: "Inscrever-se no canal do YouTube",

    // -------- Formulário de pré-inscrição (segundo plano) --------
    f_eyebrow: "Depois de assistir · Casa Alta 02",
    f_title_pre: "Se viu e pensou ",
    f_title_accent: "“eu deveria estar lá”.",
    f_body: "A próxima casa já está sendo desenhada. Deixe seu nome na pré-lista e a curadoria da Alta olha seu perfil quando as inscrições abrirem — sem compromisso, com prioridade.",
    f_scarcity: "Vagas limitadas · Seleção por curadoria · Sem custo",
    f_name: "Nome completo", f_name_ph: "Como você assina",
    f_instagram: "Instagram", f_instagram_ph: "@seuperfil",
    f_whatsapp: "WhatsApp (opcional)", f_whatsapp_ph: "+55 11 9 0000-0000",
    f_city: "Cidade", f_city_ph: "São Paulo · SP",
    f_followers: "Tamanho da audiência",
    f_followers_opts: "Até 10 mil|10 – 50 mil|50 – 200 mil|Acima de 200 mil",
    f_why: "Por que você na próxima casa?",
    f_why_ph: "Em uma frase. Sem modéstia.",
    f_consent: "Autorizo a Alta Agency a entrar em contato sobre a seleção da Casa Alta 02.",
    f_submit: "Entrar na pré-lista →",
    f_submit_loading: "Enviando...",
    f_privacy: "Seus dados são confidenciais e usados exclusivamente para a curadoria.",
    s_eyebrow: "Você está na lista",
    s_title: "Agora é com a curadoria.",
    s_body: "A Alta vai olhar seu perfil com atenção. Se fizer sentido, o próximo contato é o convite. Enquanto isso: assista aos episódios e se imagine lá.",
    s_cta: "Ver os episódios",
    s_again: "Atualizar minha inscrição",

    // -------- Encerramento --------
    c_line_pre: "22 de setembro. ",
    c_line_accent: "Sem roteiro.",
    c_cta: "Inscrever-se no canal",
    footer_line: "Casa Alta · um reality Alta Agency · 2026",
    footer_back: "Site do evento →",

    // -------- Teaser no site do evento (/evento) --------
    teaser_eyebrow: "Reality · Estreia 22.09",
    teaser_title: "O que aconteceu lá dentro\nvirou reality.",
    teaser_body: "Sete criadoras, três dias e nenhum roteiro. Quatro episódios estreiam em 22 de setembro no canal da Alta — assista ao que sobrou quando as câmeras esqueceram de desligar.",
    teaser_cta: "Ver o reality",
    teaser_note: "4 episódios · Estreia 22 de setembro",
    nav_public_link: "Reality",
  },
};

// Deep merge: overrides only leaves; keeps defaults for missing keys
export function mergeContent(overrides) {
  const out = {};
  for (const section of Object.keys(DEFAULT_CONTENT)) {
    out[section] = {
      ...DEFAULT_CONTENT[section],
      ...(overrides?.[section] || {}),
    };
  }
  return out;
}

/**
 * Returns the creators array to render.
 * If cast.creators is a non-empty array, use it.
 * Otherwise builds a legacy fallback from p1_*..p6_* keys.
 */
export function getCreators(castContent) {
  if (Array.isArray(castContent?.creators) && castContent.creators.length) {
    return castContent.creators;
  }
  const legacy = [];
  for (let n = 1; n <= 6; n++) {
    const src = castContent?.[`p${n}_src`];
    const handle = castContent?.[`p${n}_handle`];
    const vibe = castContent?.[`p${n}_vibe`];
    const reveal = !!castContent?.[`p${n}_reveal`];
    if (src || handle || vibe || reveal) {
      legacy.push({ id: `legacy-${n}`, src: src || "", handle: handle || "", vibe: vibe || "", reveal });
    }
  }
  return legacy;
}
